import React, { FunctionComponent } from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { LineItemSplitQuantityButton as LineItemSplitQuantityButtonUnified } from './LineItemSplitQuantityButton'
import { LineItemSplitQuantityButtonLegacy } from './LineItemSplitQuantityButtonLegacy'
import { LineItemSplitQuantityButtonProps } from './useLineItemSplitQuantityButtonModel'

export const LineItemSplitQuantityButton: FunctionComponent<LineItemSplitQuantityButtonProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS
  )

  return isUnifiedEnabled ? (
    <LineItemSplitQuantityButtonUnified {...props} />
  ) : (
    <LineItemSplitQuantityButtonLegacy {...props} />
  )
}
